import React from 'react';
import { Box, Container, Grid, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AnimatedSection from '../components/AnimatedSection';

const ServicesCircles = () => {
  const { t } = useTranslation();

  const services = [
    {
      key: 'consultory',
      titleKey: 'services.consultory.title',
      descriptionKey: 'services.consultory.description',
    },
    {
      key: 'development',
      titleKey: 'services.development.title',
      descriptionKey: 'services.development.description',
    },
    {
      key: 'seo',
      titleKey: 'services.seo.title',
      descriptionKey: 'services.seo.description',
    },
  ];

  const CircleContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(4),
    minHeight: '400px',
  }));

  const BlackCircle = styled(Box)(({ theme }) => ({
    width: '200px',
    height: '200px',
    borderRadius: '50%',
    backgroundColor: '#000000',
    border: '2px solid #ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
    transition: 'transform 0.3s ease, width 0.3s ease, height 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.15)',
      width: '230px',
      height: '230px',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.5)',
    },
    [theme.breakpoints.down('sm')]: {
      width: '150px',
      height: '150px',
      '&:hover': {
        width: '175px',
        height: '175px',
      },
    },
  }));

  const CircleText = styled(Typography)(({ theme }) => ({
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontFamily: 'sans-serif',
    padding: theme.spacing(1, 2),
    lineHeight: 1.3,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
      padding: theme.spacing(0.5, 1.5),
    },
  }));

  const DescriptionText = styled(Typography)(({ theme }) => ({
    color: '#333333',
    fontSize: '0.95rem',
    textAlign: 'center',
    lineHeight: 1.6,
    maxWidth: '300px',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.85rem',
      maxWidth: '100%',
    },
  }));

  return (
    <Container
      sx={{
        py: 8,
        px: 2,
        backgroundColor: 'transparent',
      }}
    >
      <Grid container spacing={4} justifyContent="center">
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={service.key}>
            <AnimatedSection direction="bottom" delay={index * 0.2}>
              <CircleContainer>
                <BlackCircle>
                  <CircleText>{t(service.titleKey)}</CircleText>
                </BlackCircle>
                <DescriptionText>{t(service.descriptionKey)}</DescriptionText>
              </CircleContainer>
            </AnimatedSection>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ServicesCircles;

